const entranceAnimation = () => {
  const entranceLink = Array.from(document.querySelectorAll('.top-entrance__link'))

  if (entranceLink.length > 0) {
    const body = document.querySelector('body')
    entranceLink.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault()
        if (link.classList.contains('top-entrance__link--shop')) {
          body.classList.add('enter-shop')
          setTimeout(() => body.classList.add('enter-end'), 1000)
          setTimeout(() => {
            window.location.href = '/dealer_search/'
          }, 2000)
        }

        if (link.classList.contains('top-entrance__link--corporate')) {
          body.classList.add('enter-corporate')
          setTimeout(() => body.classList.add('enter-end'), 1000)
          setTimeout(() => {
            window.location.href = '/corporate/'
          }, 2000)
        }
        return false
      })
    })
  }
}

export { entranceAnimation }
